import { createBilldaClient } from '@billda/api';
import { authAdapter, handleAuthFailure } from './authAdapter';
import { sharedTokenRefresh } from './axiosClient';
import {
  baseUrl,
  portalGatewayBaseUrl,
  clientType,
  appVersion,
} from './apiClientConfig';

/**
 * Delegate to the axios client's single-flight refresh so the generated client
 * and the axios stack share one refresh. The backend rotates refresh tokens, so
 * two independent refreshes would race and log the user out. `sharedTokenRefresh`
 * throws (and drives logout via onAuthFailure) on auth failure; map that to null
 * so the generated middleware surfaces the original response without double-firing.
 */
async function sharedRefresh(): Promise<string | null> {
  if (!sharedTokenRefresh) {
    return null;
  }
  try {
    return await sharedTokenRefresh();
  } catch {
    return null;
  }
}

/**
 * Typed openapi-fetch clients for the legacy (`/api/*`) and pricework
 * (`/pricework/*`) surfaces. Shares the same auth adapter and failure handler
 * as axiosClient.ts so both clients stay in sync on token refresh/logout.
 */
export const api = createBilldaClient({
  baseUrl,
  portalGatewayBaseUrl,
  authStore: authAdapter,
  onAuthFailure: handleAuthFailure,
  clientType,
  appVersion,
  sharedRefresh,
});
